// extracted by mini-css-extract-plugin
module.exports = {"card1":"CardFive_card1__DkwUh","card2":"CardFive_card2__7eMXq","card3":"CardFive_card3__vh-Ml","bigHeader":"CardFive_bigHeader__yQITu","button":"CardFive_button__2JyTK"};